import backend from './backend';

const endpoint = '/activation_link'

export default {
    post () {
        return backend.post(endpoint)
    },
    get (key) {
        return backend.get(endpoint, {params: { key }})
    }
}
